import { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type {
  DropdownIndicatorProps,
  TOption,
} from "@ab.uitools/ui-library/components/ReactSelect/types";

interface IIndicatorProps extends DropdownIndicatorProps<TOption, boolean> {
  isLightIcon?: boolean;
}

export const Indicator = ({ isLightIcon, ...props }: IIndicatorProps) => {
  const { menuIsOpen } = props.selectProps;
  return (
    <components.DropdownIndicator {...props}>
      {menuIsOpen ? (
        <CloudFlareImage
          {...props}
          size="medium"
          path={isLightIcon ? CloudflareAsset.ArrowShortUpQuaternary : CloudflareAsset.ArrowShortUp}
        />
      ) : (
        <CloudFlareImage
          {...props}
          size="medium"
          path={isLightIcon ? CloudflareAsset.ArrowShortDownQuaternary : CloudflareAsset.ArrowShortDown}
        />
      )}
    </components.DropdownIndicator>
  );
};

export const DropdownIndicator = (props: DropdownIndicatorProps<TOption, boolean>) => (
  <Indicator {...props} />
);

export const DropdownIndicatorLight = (props: DropdownIndicatorProps<TOption, boolean>) => (
  <Indicator {...props} isLightIcon/>
);

